module.exports = __webpack_public_path__ + "static/media/eachPerson.2cf39077.png";